import React, { Component } from "react";
import IndicatorBanner from "./../../../components/indicators/IndicatorBanner";
import { isNotPlanned, isNotVisited, isPlaned, isVisited } from "./Calendar.utils";

class Header extends Component {
  getPlanifies(events) {
    //const events = this.state.events || [];
    let nb = 0;

    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      if (isPlaned(event)) {
        nb++;
      }
    }

    return nb;
  }

  getNonPlanifies(events) {
    let nb = 0;
    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      if (isNotPlanned(event)) {
        nb++;
      }
    }
    return nb;
  }

  getNbRdv(events) {
    let nb = 0;
    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      if (event.rdv) {
        nb++;
      }
    }
    return nb;
  }

  getNbSpeedy(events) {
    let nb = 0;
    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      if (event.event_type_id === 11 || event.event_type_id === 9) {
        nb++;
      }
    }
    return nb;
  }

  getNbNonVisites(events) {
    let nb = 0;
    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      if (isNotVisited(event)) {
        nb++;
      }
    }
    return nb;
  }

  getNbVisites(events) {
    let nb = 0;
    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      if (isVisited(event)) {
        nb++;
      }
    }

    return nb;
  }

  render() {
    const { currentDateRange, events } = this.props;
    const eventsRangeFiltered = events.filter(event => {
      const eventFiltered = event;

      eventFiltered.start = new Date(event.start).getTime();
      eventFiltered.end = new Date(event.end).getTime();

      return eventFiltered.start >= currentDateRange.start && eventFiltered.end <= currentDateRange.end;
    });

    return (
      <IndicatorBanner
        size="large"
        items={[
          {
            label: "Planifiés",
            color: "#21a779",
            value: this.getPlanifies(eventsRangeFiltered)
          },
          {
            label: "Non planifiés",
            color: "#4768bb",
            value: this.getNonPlanifies(eventsRangeFiltered)
          },
          {
            label: "Visités",
            color: "#8651db",
            value: this.getNbVisites(eventsRangeFiltered)
          },
          {
            label: "Non visités",
            color: "#d13d3d",
            value: this.getNbNonVisites(eventsRangeFiltered)
          },
          {
            label: "Nombre de rdv",
            color: "#efa319",
            value: this.getNbRdv(eventsRangeFiltered)
          },
          {
            label: "RDV SPEEDY/ADMIN",
            color: "#0166d9",
            value: this.getNbSpeedy(eventsRangeFiltered)
          }
        ]}
      />
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// src/containers/activite/planning/Indicators.js